import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SelectComponent implements ControlValueAccessor {

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() label?: string;
  @Input() options: string[] = []; // Options for the select

  @Input() formControlName?: string;
  @Input() control!: FormControl;

  isFocused: boolean = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor() {}

  handleValueChange(event: any) {
    this.writeValue(event);
  }

  writeValue(value: any): void {
    if (this.control && value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(value => {
      this.valueChange.emit(value);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  handleFocus() {
    this.isFocused = true;
    this.onTouched();
  }

  handleBlur() {
    this.isFocused = false;
  }
}